

<template>
  <div class="container">
    <h1>Importação de CT-e</h1>

    <success-fade-alert ref="successFadeAlert" :msg="alert.success" />
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />

    <b-row>
      <b-col sm="12" md="12" lg="12">
        <b-form-group label="Anexo" label-for="file">
          <b-form-file
            :lang="$i18n.locale"
            id="file"
            ref="file"
            :placeholder="$t('geral.escolhaArquivo')"
            v-on:change="handleFileUpload($event)"
            :no-drop="true"
          ></b-form-file>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-button type="submit" variant="primary" v-on:click="submitFile()">Importar</b-button>
    </b-row>
    <div class="large-12 medium-12 small-12 cell">
      <br />
      <br />
      <h3>Status do processamento</h3>
      <import-status ref="CteImportStatus"></import-status>
    </div>
  </div>
</template>

<script>
import CteImportStatus from "./CteImportStatus";
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";

export default {
  components: {
    "success-fade-alert": SuccessFadeAlert,
    "fade-alert-danger": FadeAlertDanger,
    "import-status": CteImportStatus,
  },
  data: function () {
    return {
      file: null,
      importacaoId: null,
      alert: {
        error: "",
        success: "",
      },
    };
  },
  methods: {
    handleFileUpload(e) {
      this.file = e.target.files[0];
    },
    submitFile() {
      if (this.file != null) {
        let formData = new FormData();
        formData.append("file", this.file);

        this.$api
          .get("/cte/beginImport")
          .then((response) => {
            if (response) {
              this.importacaoId = response.data.data.id;
              this.$refs.CteImportStatus.initializeTimer(this.importacaoId);
              console.log("this.$refs.CteImportStatus.initializeTimer");
              console.log(this.importacaoId)
            }
            this.$api
              .post("/cte/importzip", formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              })
              .then((data) => {
                console.log("sucesso!");
                console.log(data.data);
                this.$refs.CteImportStatus.finishProcess();
                this.alert.success = "Conhecimentos eletrônicos importados com sucesso!"; //data.data.message;
                this.$refs.successFadeAlert.show();
              })
              .catch((error) => {
                if (error.response) {
                  this.alert.error = error.response.data.errors;
                  this.$refs.fadeAlertDanger.show();
                } else {
                  this.alert.error = error.message;
                  this.$refs.fadeAlertDanger.show();
                }
              });
          })
          .catch((error) => {
            if (error.response) {
              this.alert.error = error.response.data.errors;
              this.$refs.fadeAlertDanger.show();
            } else {
              this.alert.error = error.message;
              this.$refs.fadeAlertDanger.show();
            }
          });
      }
    },    
    // submitFile() {
    //   let formData = new FormData();
    //   formData.append("file", this.file);
    //   alert("Importação iniciada");

    //   axios
    //     .post("http://3.136.82.117:81/cte/importzip/", formData, {
    //       headers: {
    //         "Content-Type": "multipart/form-data",
    //       },
    //     })
    //     .then(function (data) {
    //       console.log(data.data.message);
    //       console.log(data.data);
    //       alert(data.data.message);
    //     })
    //     .catch(function (error) {
    //       console.log(error);
    //       console.log(error.response.data.errors);

    //       if (error.response.status == 400) {
    //         alert(error.response.data.errors);
    //       }
    //     });
    // },
    // submitFileXml() {
    //   let formData = new FormData();
    //   formData.append("file", this.fileXml);
    //   alert("Importação iniciada");

    //   axios
    //     .post("http://3.136.82.117:81/cte/importxml/", formData, {
    //       headers: {
    //         "Content-Type": "multipart/form-data",
    //       },
    //     })
    //     .then(function (data) {
    //       console.log(data.data.message);
    //       console.log(data.data);
    //       alert(data.data.message);
    //     })
    //     .catch(function (error) {
    //       console.log(error);
    //       console.log(error.response.data.errors);

    //       if (error.response.status == 400) {
    //         alert(error.response.data.errors);
    //       }
    //     });
    // },
  },
};
</script>
